import LazyImage from "@/my_components/Common/LazyImage";
import Link from "next/link";
import { useTranslation } from "react-i18next";

import BlogData from "@/data/blog/blog.json";
import { image_url } from "@/helper/Utilities";
import { blogPostSlug } from "@/helper/SpecialHelpers";
import { ROUTE } from "@/route/app_routes.js";


const BlogGridMinimal = () => {

  const { t } = useTranslation("blog");
  const latestPosts = BlogData.blogList.slice(0, 3);

  return (
    <>
      <div className="row g-5">
        {latestPosts.map((post) => {
          const href = ROUTE.blog_details + blogPostSlug(post);
          const title = t(`posts.${post.id}.title`, post.title);
          return (
            <div className="col-lg-4 col-md-6 col-sm-6 col-12 mt--30" key={post.id}>
              <div className="rbt-card variation-02 rbt-hover card-minimal">
                <div className="rbt-card-img">
                  <Link href={href}>
                    <LazyImage src={image_url(post.img)} width={400} height={220} alt={title} />
                  </Link>
                </div>
                <div className="rbt-card-body">
                  <ul className="meta-list justify-content-start mb--20">
                    <li className="list-item">
                      <i className="feather-clock"></i>
                      <span>{post.date}</span>
                    </li>
                  </ul>

                  <h4 className="rbt-card-title">
                    <Link href={href}>{title}</Link>
                  </h4>

                  <div className="rbt-card-bottom mt--20">
                    <Link className="transparent-button" href={href}>
                      {t("list.learnMore", "Learn More")}
                      <i> <svg width="17" height="12" xmlns="http://www.w3.org/2000/svg"> <g stroke="#27374D" fill="none" fillRule="evenodd"> <path d="M10.614 0l5.629 5.629-5.63 5.629" /> <path strokeLinecap="square" d="M.663 5.572h14.594" /> </g> </svg> </i>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default BlogGridMinimal;
